// Modules
import { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
// Material-UI
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Stack
} from "@mui/material";
// Helpers
import { RANGE_CURRENT, RECURRENCE_RANGES } from "../../../../helpers/constants";
// Styles
import { gridSpacing } from "../../../../styles/constants";

const RecurrenceRangeForm = ({ handleChangeRecurrenceRange, onCancel, view }) => {
    const [range, setRange] = useState(RANGE_CURRENT);

    return (
        <>
            <DialogTitle>{<FormattedMessage id={`${view}-recurring-event`} />}</DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <FormControl>
                            <RadioGroup
                                row
                                aria-label="range"
                                onChange={e => setRange(e.target.value)}
                                name="recurrence-range-radio-buttons-group"
                                sx={{ "& .MuiFormControlLabel-root": { mr: 0 } }}
                                value={range}
                            >
                                {RECURRENCE_RANGES.map(item => (
                                    <Grid item xs={12} key={item}>
                                        <FormControlLabel
                                            value={item}
                                            control={<Radio />}
                                            label={<FormattedMessage id={`range-${item}`} />}
                                        />
                                    </Grid>
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 3 }}>
                <Grid container justifyContent="flex-end" alignItems="center">
                    <Grid item>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Button type="button" variant="outlined" onClick={onCancel}>
                                <FormattedMessage id="cancel" />
                            </Button>
                            <Button
                                type="button"
                                variant="contained"
                                onClick={() => {
                                    handleChangeRecurrenceRange(range);
                                }}
                            >
                                <FormattedMessage id="ok" />
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </DialogActions>
        </>
    );
};

RecurrenceRangeForm.propTypes = {
    handleChangeRecurrenceRange: PropTypes.func,
    onCancel: PropTypes.func,
    view: PropTypes.string
};

export default RecurrenceRangeForm;
